var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "livelist-wrapper" }, [
    _c(
      "div",
      { staticClass: "header" },
      [
        _c("van-icon", {
          attrs: { name: "arrow-left", size: "20", color: "#333" },
          on: { click: _vm.goBack }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "top_title" }, [
          _vm.type == 1
            ? _c("span", [_vm._v("直播出勤情况")])
            : _c("span", [_vm._v("视频完成情况")])
        ]),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "shop_detail",
            class: { active: _vm.flag },
            on: {
              click: function($event) {
                _vm.flag = !_vm.flag
              }
            }
          },
          [
            _vm._v("\n      筛选\n      "),
            _vm.flag
              ? _c("img", {
                  attrs: {
                    src: require("../../../static/images/ic_preview_open.png")
                  }
                })
              : _c("img", {
                  attrs: {
                    src: require("../../../static/images/ic_preview_close.png")
                  }
                })
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.flag && _vm.type == 1
      ? _c("div", { staticClass: "screen_wrapper" }, [
          _c("div", { staticClass: "screen_content" }, [
            _c("div", { staticClass: "first_screen" }, [
              _c(
                "p",
                {
                  class: _vm.current == 1 ? "bg" : "",
                  on: {
                    click: function($event) {
                      _vm.close(1, 0), (_vm.current = 1), (_vm.isshow = false)
                    }
                  }
                },
                [_vm._v("不限")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  class: _vm.current == 2 ? "bg" : "",
                  on: {
                    click: function($event) {
                      _vm.close(1, 1), (_vm.current = 2), (_vm.isshow = false)
                    }
                  }
                },
                [_vm._v("未出勤")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  class:
                    _vm.current == 3 ||
                    _vm.current == 4 ||
                    _vm.current == 5 ||
                    _vm.current == 6
                      ? "bg"
                      : "",
                  on: {
                    click: function($event) {
                      ;(_vm.isshow = true), (_vm.current = 3)
                    }
                  }
                },
                [_vm._v("已出勤")]
              )
            ]),
            _vm._v(" "),
            _vm.isshow
              ? _c("div", { staticClass: "second_screen" }, [
                  _c(
                    "p",
                    {
                      class: _vm.current == 4 ? "bg" : "",
                      on: {
                        click: function($event) {
                          _vm.close(1, 2, 0), (_vm.current = 4)
                        }
                      }
                    },
                    [_vm._v("不限")]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      class: _vm.current == 5 ? "bg" : "",
                      on: {
                        click: function($event) {
                          _vm.close(1, 2, 2), (_vm.current = 5)
                        }
                      }
                    },
                    [_vm._v("未有效出勤")]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      class: _vm.current == 6 ? "bg" : "",
                      on: {
                        click: function($event) {
                          _vm.close(1, 2, 1), (_vm.current = 6)
                        }
                      }
                    },
                    [_vm._v("有效出勤")]
                  )
                ])
              : _vm._e()
          ])
        ])
      : _vm.flag && _vm.type == 2
      ? _c("div", { staticClass: "screen_wrapper" }, [
          _c("div", { staticClass: "screen_content" }, [
            _c("div", { staticClass: "first_screen" }, [
              _c(
                "p",
                {
                  class: _vm.current == 1 ? "bg" : "",
                  on: {
                    click: function($event) {
                      _vm.close(2, 0), (_vm.current = 1), (_vm.isshow = false)
                    }
                  }
                },
                [_vm._v("不限")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  class: _vm.current == 2 ? "bg" : "",
                  on: {
                    click: function($event) {
                      _vm.close(2, 1), (_vm.current = 2), (_vm.isshow = false)
                    }
                  }
                },
                [_vm._v("未观看")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  class: _vm.current == 3 ? "bg" : "",
                  on: {
                    click: function($event) {
                      _vm.close(2, 2), (_vm.current = 3)
                    }
                  }
                },
                [_vm._v("已观看")]
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type == 1
      ? _c(
          "div",
          { staticClass: "livelist_content" },
          _vm._l(_vm.data, function(i, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "livelist_detail",
                on: {
                  click: function($event) {
                    return _vm.godetail(i)
                  }
                }
              },
              [
                _c("p", { staticClass: "lesson_name" }, [
                  i.attendance_status != 1
                    ? _c("span", { staticClass: "tag dttendance_tag" }, [
                        _vm._v("未出勤")
                      ])
                    : _c("span", [
                        i.enffect_attendance_status == 1
                          ? _c("span", { staticClass: "tag attendance_tag" }, [
                              _vm._v("有效出勤")
                            ])
                          : _c("span", { staticClass: "tag ettendance_tag" }, [
                              _vm._v("未有效出勤")
                            ])
                      ]),
                  _vm._v("\n        " + _vm._s(i.lesson_name) + "\n      ")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "live_time" }, [
                  _vm._v(
                    "\n        直播时间：" +
                      _vm._s(_vm.formatTime(i.start_time)) +
                      "\n        "
                  ),
                  i.offline_code
                    ? _c("span", { staticClass: "live_tag is_playback" }, [
                        _c("span"),
                        _vm._v("看回放\n        ")
                      ])
                    : _c("span", { staticClass: "live_tag" }, [
                        _vm._v("暂无回放")
                      ])
                ])
              ]
            )
          }),
          0
        )
      : _vm.type == 2
      ? _c(
          "div",
          { staticClass: "livelist_content" },
          _vm._l(_vm.data, function(i, index) {
            return _c(
              "div",
              {
                key: index,
                on: {
                  click: function($event) {
                    return _vm.godetail(i)
                  }
                }
              },
              [
                _c("p", { staticClass: "live_path" }, [_vm._v(_vm._s(i.path))]),
                _vm._v(" "),
                _vm._l(i.list, function(item, idx) {
                  return _c(
                    "div",
                    {
                      key: idx,
                      staticClass: "livelist_detail",
                      on: {
                        click: function($event) {
                          return _vm.godetail(i)
                        }
                      }
                    },
                    [
                      _c("p", { staticClass: "lesson_name" }, [
                        _vm._v(_vm._s(item.name))
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "live_time" }, [
                        _vm._v(
                          "累计观看时长：" +
                            _vm._s(_vm.formatTime(i.start_time))
                        )
                      ])
                    ]
                  )
                })
              ],
              2
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a961c3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a961c3c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/attendance/index.vue
// module id = null
// module chunks = 